export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fe12566b2d84dcd199e06b68e416636e6e75cba7a&name=fetchTypeahead!'